import driverService from "@/api/driverService";
import router from '@/router/index';
import { MESSAGES } from '@/utils/constants';
// import { resetSeconds } from "@/utils/date-helpers";
 import FileSaver from 'file-saver'
import { notifyApiError, notify, notifyError } from '@/utils/notification-helper';

const state = {

    newDriver: '',
    editId: null,
    additionalDetails: [
    ],
    metadata: {},
    fileUrlView: null,
    fileUrlDownload: null,
    driverFileList: [],
    loader:false,
    EmployeeErrors:[],
    imageUrl: null,
    bulkFiles:null,
}
const getters = {
    driverList: (state, getters, rootState, rootGetters) => rootGetters.getDrivers.map((d) => ({ ...d, gender: d.gender === 'm' ? 'Male' : 'Female'})),
    drvr: state => state.newDriver,
    driverFileList: state => state.driverFileList,
    fileUrlView: state => state.fileUrlView,
    fileUrlDownload: state => state.fileUrlDownload,
    getSelectedFacility: (state, getters, rootState) => {
        return rootState.selectedFacility;
    },
};

const actions = {
    async addDriver({ commit, rootState, dispatch }, driver) {
        let id = rootState.selectedFacility ? rootState.selectedFacility.id : 0
        driver.facilityID = id;
        try {
        const response = await driverService.addDriver(driver);
        if(response.data.result.id && state.bulkFiles) { 
            let data = {
               id:response.data.result.id,
               data:state.bulkFiles
            }
            dispatch("uploadFile",data);
            notify(MESSAGES.CHANGES_SAVE_SUCCESS);
        }
        commit('addDriver', response.data.result, { root: true });
        return true;
        } catch (error) {
            if (error.response.status == 409) {
                notifyError(error.response.data.message);
                return false;
            } else {
                notifyError(MESSAGES.CHANGES_SAVE_ERROR);
                return false;
            }
        }
    },
    async editDriver({ commit }, driver) {
        commit('edit', { ...driver, gender: driver.gender === "Male" ? "m" : "f" });
    },
    async updateDriver({ state, commit, dispatch }, driver) {
        try {
        const response = await driverService.updateDriver(state.editId, driver);
        console.info('Response from Add Driver API ', response.data);

        if(state.editId && state.bulkFiles)
        { 
            let data={
                id:state.editId,
                data:state.bulkFiles
            }  
            dispatch("uploadFile",data);
        }
        notify(MESSAGES.CHANGES_SAVE_SUCCESS);

        commit('updateDriver', response.data.result, { root: true });
        // commit('update', driver);
        } catch (error) {
            console.error('Error in Update : ', error);
            if (error.response.status == 409) {
                notifyError(error.response.data.message);
            } else {
                notifyError(MESSAGES.CHANGES_SAVE_ERROR);
            }
        }
    },
    async removeDriver({ commit }, driver) {
        await driverService.deleteDriver(driver.dataItem.id);
        commit('removeDriver', driver.dataItem.id, { root: true });
        // commit('remove', driver);
    },
    async getColumn({ commit }) {
        const res = await driverService.getColumn()
        commit('getColumn', res.data.result)
    },
    async getDriverFileList({ commit,rootState }, id) {
        let channelKey = rootState.fileUploadChannelKey
        try {
            const res = await driverService.getDriverFile(channelKey,id)
            commit('getFile', res.data.result);
        } catch (error) {
            console.error("Error while fetching file List : ", error);
            commit('getFile', 'Data not available');
            return false;
        }
    },
    async uploadFile({ commit ,rootState}, data) {
        data.channelKey = rootState.fileUploadChannelKey
        // console.log("channelkey",data)
        await driverService.uploadFile(data)
        commit('upload')
    },
    async deleteFile({ commit,rootState }, data) {
        // await driverService.deleteFile(id)
        // commit('delete', id)
        data.channelKey = rootState.fileUploadChannelKey
        if(data.referenceID) { 
            let res= await driverService.deleteFile(data)
            if(res.status == 200){
            commit('deleteFile', data)
            notify("Deleted Successfully") 
            }
            else {
            notifyError("Error") 
            }
        }
        else{
            commit('deleteFile', data)
        }
      //    console.log(res)
        
    },
    async viewFile({ commit,rootState }, id) {
        let channelKey = rootState.fileUploadChannelKey
        const response = await driverService.viewFile(channelKey,id)
        commit('setUrlView', response.data.result)
    },
    async downloadFile({commit,rootState }, id) {
        let channelKey = rootState.fileUploadChannelKey
        const response = await driverService.downloadFile(channelKey,id)
        commit('setUrlDownload', response.data.result)
    },
    async DownloadTemp({ commit }) {
        await driverService.DriverDownloadTemplate().then(({ data }) => {
            FileSaver(data, 'Driver' + '.xlsx')
        }).catch(notifyApiError);
        commit('downloadData')
    },
    async uploadTemplate({ commit }, event) {
        let data = new FormData();
        let file = event.target.files[0];
        data.append('name', 'my-file')
        data.append('file', file)
        let config = {
            header: {
                'Content-Type': 'multipart/form-data',
            }
        }
        await driverService.DriverUploadTemplate(data, config).then((res) => {
            state.EmployeeErrors = []
            let resData = res.data.templateErrorMessage;
            if (resData.length != 0) {
                notifyError(MESSAGES.RESOLVE_ERRORS)
                 commit("employeeError", resData)
            }
            else {
                notify(MESSAGES.TEMPLATE_UPLOAD_SUCCESS)
                res.data.bulkDriversResponse.result.forEach((ele) => {
                    commit('addDriver', ele, { root: true });
                });
                // dispatch('getDriver');
            }
        }).catch((err) => {
            notifyApiError(err)
        })
    },
    async uploadImage({commit,rootState},file){
        console.log('Upload image....');
        let data = {
             id: state.newDriver.id,
             data:file,
             channelKey : rootState.fileUploadChannelKey
         }
         const resp= await driverService.DriverUploadImageV2(data)
             console.log('driver',resp.data.result)
             commit('assignUrl',resp.data.result.fileUrl)
        
     },
}
const mutations = {
    get(state, driver) {
        for (var indx = 0; indx < driver.length; indx++) {
            if (driver[indx].gender === 'm')
                driver[indx].gender = 'Male'
            else
                driver[indx].gender = "Female"
        }
        state.drivers = driver
    },
    edit(state, driver) {
        state.editId = driver.id
        state.newDriver = driver
        state.metadata = driver.metaData ? driver.metaData : {}
        router.push({ name: "driverAddUpdate", params: { add: false } });
    },
    getColumn(state, data) {
        state.additionalDetails = data

    },
    setUrlView(state, url) {
        state.fileUrlView = url
    },
    setUrlDownload(state, url) {
        state.fileUrlDownload = url
    },
    getFile(state, item) {
        if (item == 'Data not available') {
            state.driverFileList = []
        }
        else {
            state.driverFileList = item

        }

    },
    employeeError(state, data) {
    //    console.log("error",data)
        data.map(data => {
            if (data.error) {
                state.EmployeeErrors.push({ error: data.error, email: data.notAddedEmployee.emailID, empID: data.notAddedEmployee.employeeCode, empName: data.notAddedEmployee.name, })
            }
            else {
                state.EmployeeErrors.push({ error: data.errorMessage, cell: data.cell })
            }
        })
    },
    clearFields(state){
        state.newDriver = {}
        state.driverFileList = []
    },
    addTempFile(state,file){
    //   file.map(i=>{
        state.driverFileList.push({"fileName":file.name,"fileType":file.type,"fileUrl":"Local storage",id:file.id})
    //  })
    //  state.driverFileList.push(data)
    },
    assignBulkFile(state,files){
        state.bulkFiles = files
    },
    deleteFile(state,data){
        if(data.referenceID)
        {const index = state.driverFileList.map(item => item.id).indexOf(data.id)
        state.driverFileList.splice(index, 1)}
        else{
            const index = state.driverFileList.map(item => item.id).indexOf(data.id) 
            state.driverFileList.splice(index, 1)
        }
    },
    downloadData(){

    },
    cancel(state) {
        state.metadata = {}
    },
    assignUrl(state, url){
        state.imageUrl = url;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}